document.addEventListener('DOMContentLoaded', function() {
    var teaTypeLink = document.getElementById('tea-type-link');
    var teaTypeValue = teaTypeLink.getAttribute('data-tea-type').toLowerCase();
    
    // Convert tea type to slug format
    var slugMap = {
        "black": "black-tea",
        "chai": "chai-tea",
        "green": "green-tea",
        "herbal": "herbal-tea",
        "oolong": "oolong-tea",
        "rooibos": "rooibos-tea",
        "white": "white-tea",
        "yerba maté": "yerba-mate-tea"
    };
    
    // Get the slug based on the tea type value
    var slug = slugMap[teaTypeValue];
    
    if (slug) {
        // Update the href attribute of the tea type link
        teaTypeLink.setAttribute('href', '/collections/' + slug);
        teaTypeLink.textContent = teaTypeValue.charAt(0).toUpperCase() + teaTypeValue.slice(1) + ' Tea';
    } else {
        teaTypeLink.remove(); // Remove the link if tea type is not found
    }
});

